function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_11_105)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 84.75,
  y1: 176,
  x2: 84.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 104.75,
  y1: 176,
  x2: 104.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 124.75,
  y1: 176,
  x2: 124.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 144.75,
  y1: 176,
  x2: 144.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 164.75,
  y1: 176,
  x2: 164.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 184.75,
  y1: 176,
  x2: 184.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.75,
  y1: 176,
  x2: 204.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 224.75,
  y1: 176,
  x2: 224.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 244.75,
  y1: 176,
  x2: 244.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 264.75,
  y1: 176,
  x2: 264.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 284.75,
  y1: 176,
  x2: 284.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 304.75,
  y1: 176,
  x2: 304.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 324.75,
  y1: 176,
  x2: 324.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 344.75,
  y1: 176,
  x2: 344.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 364.75,
  y1: 176,
  x2: 364.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 384.75,
  y1: 176,
  x2: 384.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 404.75,
  y1: 176,
  x2: 404.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 424.75,
  y1: 176,
  x2: 424.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 444.75,
  y1: 176,
  x2: 444.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 464.75,
  y1: 176,
  x2: 464.75,
  y2: 48,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 55,
  y1: 71.75,
  x2: 495,
  y2: 71.75,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 55,
  y1: 91.75,
  x2: 495,
  y2: 91.75,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 55,
  y1: 111.75,
  x2: 495,
  y2: 111.75,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 55,
  y1: 131.75,
  x2: 495,
  y2: 131.75,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 55,
  y1: 151.75,
  x2: 495,
  y2: 151.75,
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M175 112H375M375 112L371.312 109M375 112L371.312 115",
  stroke: "url(#paint0_linear_11_105)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M275 176V48M275 48L272 51M275 48L278 51",
  stroke: "url(#paint1_linear_11_105)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211 176C211 176 232.074 112 275 112C317.926 112 339 48 339 48",
  stroke: "url(#paint2_linear_11_105)",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 359,
  y1: 49.4142,
  x2: 255.414,
  y2: 153,
  stroke: "url(#paint3_linear_11_105)",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368 86.2143V85.5C368 84.1193 366.881 83 365.5 83V83C364.119 83 363 84.1193 363 85.5V98.5C363 99.8807 361.881 101 360.5 101V101C359.119 101 358 99.8807 358 98.5V97.7857M360.5 89.4286H365.5M368 95.8571L373 101M373 95.8571L368 101",
  stroke: "url(#paint4_linear_11_105)",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M342.134 84.5C342.519 83.8333 343.481 83.8333 343.866 84.5L352.526 99.5C352.911 100.167 352.43 101 351.66 101H334.34C333.57 101 333.089 100.167 333.474 99.5L342.134 84.5Z",
  stroke: "url(#paint5_linear_11_105)",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_11_105)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M416.292 87.8723C412.634 96.9721 417.009 107.329 426.064 111.006L439.313 78.0527C430.258 74.3762 419.951 78.7726 416.292 87.8723Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438.32 94.0775C434.139 104.477 439.139 116.314 449.488 120.516C459.837 124.718 471.616 119.693 475.797 109.293L438.32 94.0775Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.194 48C486.13 53.2522 492.38 68.0482 487.154 81.0479C481.927 94.0475 467.203 100.328 454.267 95.0759L473.194 48Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427.152 67.6392C430.288 59.8394 439.122 56.0711 446.884 59.2224C454.646 62.3737 458.396 71.2513 455.26 79.0511L427.152 67.6392Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438.661 78.3352L425.79 110.347C417.306 106.615 413.263 96.7482 416.756 88.0588C420.25 79.3696 429.978 75.0955 438.661 78.3352ZM449.676 120.053C439.738 116.018 434.855 104.762 438.602 94.7318L475.142 109.567C470.905 119.398 459.613 124.087 449.676 120.053ZM454.918 94.7955L473.469 48.6566C485.834 53.9663 491.752 68.2719 486.69 80.8614C481.628 93.4507 467.483 99.6093 454.918 94.7955ZM454.976 78.396L427.809 67.3665C430.999 60.1346 439.346 56.7016 446.696 59.6857C454.046 62.6698 457.679 70.9667 454.976 78.396Z",
  stroke: "white",
  strokeOpacity: 0.08
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_11_105)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.1838 125.648C66.1838 108.721 80.0701 95 97.1998 95C114.329 95 128.216 108.721 128.216 125.648V125.658C123.74 127.502 118.829 128.521 113.678 128.521C111.799 128.521 109.952 128.385 108.146 128.124C104.799 138.891 94.6559 146.718 82.6624 146.718C79.3061 146.718 76.0948 146.105 73.1367 144.986C68.7899 139.711 66.1838 132.98 66.1838 125.648Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.101 130.916C122.985 130.916 129.44 129.097 135 125.919C134.853 146.423 117.986 163 97.2003 163C80.1193 163 65.6844 151.805 61 136.436C61.3238 136.623 61.6519 136.803 61.9842 136.977C66.2705 145.853 75.4374 151.986 86.0539 151.986C99.0187 151.986 109.822 142.84 112.214 130.721C113.492 130.85 114.788 130.916 116.101 130.916Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.218 127.629L107.795 127.568L107.669 127.975C104.386 138.536 94.4341 146.218 82.6624 146.218C79.4145 146.218 76.306 145.633 73.4381 144.565C69.2127 139.392 66.6838 132.812 66.6838 125.648C66.6838 109.003 80.3406 95.5 97.1998 95.5C113.949 95.5 127.538 108.828 127.714 125.323C123.382 127.062 118.644 128.021 113.678 128.021C111.823 128.021 110 127.887 108.218 127.629ZM116.101 131.416C122.761 131.416 129.026 129.735 134.484 126.779C133.879 146.603 117.424 162.5 97.2003 162.5C81.2169 162.5 67.5847 152.569 62.2745 138.616C66.9017 146.887 75.8173 152.486 86.0539 152.486C99.0995 152.486 110.001 143.393 112.613 131.261C113.762 131.363 114.925 131.416 116.101 131.416Z",
  stroke: "white",
  strokeOpacity: 0.08
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_11_105",
  x: 367,
  y: 0,
  width: 170,
  height: 170,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_105"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_105",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_11_105",
  x: 13,
  y: 47,
  width: 170,
  height: 164,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_105"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_105",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_11_105",
  x1: 375,
  y1: 112,
  x2: 175,
  y2: 112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_11_105",
  x1: 275,
  y1: 48,
  x2: 275,
  y2: 176,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_11_105",
  x1: 211,
  y1: 112,
  x2: 339,
  y2: 112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_11_105",
  x1: 253.637,
  y1: 152.637,
  x2: 358.637,
  y2: 47.6365,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A862"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00AF92"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_11_105",
  x1: 358,
  y1: 92,
  x2: 373,
  y2: 92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_11_105",
  x1: 331,
  y1: 95,
  x2: 355,
  y2: 95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11_105"
}, /*#__PURE__*/React.createElement("rect", {
  width: 440,
  height: 128,
  fill: "white",
  transform: "translate(55 48)"
})));

function SvgDerivatives(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 223,
    viewBox: "0 0 550 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerivatives);
export default __webpack_public_path__ + "static/media/Derivatives.479db66bb373cbdc1e3b95b1a321a51a.svg";
export { ForwardRef as ReactComponent };